import styled from "styled-components";
import { breakpoints } from "theme/themes";


const StepLearnMoreTop = styled.div`

  @media ${breakpoints.larger} {
    height: fit-content;
  }
`;

export default StepLearnMoreTop
